import React, { useState } from 'react';
import { toast } from 'react-toastify';
import IconMail from '../../images/common/icon_mail.png';
import IconMail2x from '../../images/common/icon_mail@2x.png';
import { useApi } from '../../hooks/useApi';

const Email = () => {
  const [ email, setEmail ] = useState("");
  const { post } = useApi();

  const validateInput = () => {
    const regEmail = /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
    return regEmail.test(email);
  }

  const sendResetLink = () => {
    if (!validateInput()) {
      toast.error("有効なメールアドレスを入力してください。");
      return;
    }

    post({
      endpoint: '/api/v1/password_resets',
      skipAuth: true,
      body: {
        email: email
      },
      onSuccess: () => {
        setEmail("");
        toast.success("パスワードリセットのメールを送信しました。");
      },
      onError: (err) => {
        console.error(err);
        toast.error("メールの送信に失敗しました。時間をおいて再度お試しください。");
      }
    });
  }

  return (
    <section>
      <h2 className="curve_title">
        <img
          src={ IconMail }
          srcSet={ `${ IconMail } 1x, ${ IconMail2x } 2x` }
          alt="パスワードをリセット"
        />
        パスワードをリセット
      </h2>
      <div className="form">
        <p className="mb_20">登録したメールアドレスを入力してください。パスワードリセット用のリンクを記載したメールを送信します。</p>
        <dl className="graf_list">
          <dt>メールアドレス</dt>
          <dd>
            <input
              type="email"
              value={ email }
              onChange={ e => setEmail(e.target.value) }
              onKeyUp={ e => e.key === 'Enter' && validateInput() && sendResetLink() }
              placeholder="メールアドレス"
            />
          </dd>
        </dl>
        <button
          className="w_bluebtn"
          type="submit"
          onClick={ () => sendResetLink() }
        >
          送信
        </button>
      </div>
    </section>
  );
}

export default Email;
